<div class="cpp-add-prod retailerSearch margin-r0">
  <h3 class="dialogHeader">Select Retailer</h3>

  <div class="form-sec">
    <div class="row md-mr-0">
      <div class="col-md-10 col-lg-12 smallPadRgt0">
        <app-efulfillmentfilter [filters]="filterArray" (SearchFilter)="filterGrid($event)" [IsAccountTab]='true'></app-efulfillmentfilter>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mobile-pad-0 retailerSearchTable">
      <app-efulfillmenttable [propHeaderDS]="headerList" [propBodyDS]="dataSourceList" (RowClick)="TableRowClicked($event)"></app-efulfillmenttable>
    </div>
  </div>
  <div class="row retailer-footer">
    <div class="col-12 account-footer">
      <div class="row">
        <div class="col-6 padding-20">
          <button data-testid="ddl-select-account" mat-raised-button class="btns margin-r15 xs-button" color="primary" [disabled]="!accountSelected" (click)="selectAccountClicked()">Select Retailer</button>
        </div>
        <div class="col-6 text-right m-auto padding-r30">
          <div>RETAILER COUNT: {{dataSourceList?.length}} </div>
        </div>
      </div>
    </div>
  </div>
</div>
